import { Seo } from "../components/Seo";
import { SensorFinder } from "../components/SensorFinder";
import { BrandMarquee } from "../components/BrandMarquee";
import { Reveal } from "../components/Reveal";

export default function CompatibilityPage() {
  return (
    <main className="bg-[#0E1118] pt-24 sm:pt-32 min-h-screen">
      <Seo
        title="السيارات والحساسات المتوافقة | حساسات كفرات الرياض"
        description="اعرف الحساس المتوافق مع سيارتك: تويوتا، لكزس، نيسان، هيونداي، فورد، مرسيدس وغيرها. التوافق يعتمد على الموديل وسنة الصنع ونوع النظام — استفسر عبر واتساب."
        path="/compatibility"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
        <Reveal className="max-w-3xl">
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight leading-[1.2] mb-6">
            السيارات والحساسات المتوافقة
          </h1>
          <p className="text-slate-300 leading-relaxed text-base sm:text-lg">
            تختلف حساسات ضغط الإطارات بين السيارات في التردد والبروتوكول وشكل
            الصمام. لا نعرض نتائج توافق مؤكدة دون مراجعة بيانات سيارتك — أدخل
            بياناتك في النموذج وسنساعدك في تحديد الحساس المناسب بعد مراجعة
            بيانات السيارة.
          </p>
        </Reveal>
      </div>
      <SensorFinder compact />
      <BrandMarquee />
    </main>
  );
}
